const FilterFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6442 4.1377C19.8966 4.1377 20.1275 4.28022 20.2406 4.50593C20.3539 4.73201 20.3296 5.00272 20.1779 5.20503L14.3075 13.092V17.8129C14.3068 18.2327 14.1092 18.6278 13.7739 18.8802L12.4397 19.8809C12.2089 20.0544 11.9279 20.148 11.6392 20.1477C10.9046 20.1422 10.3105 19.5481 10.305 18.8135V13.092L4.43469 5.20503C4.28309 5.00289 4.2587 4.73245 4.3717 4.50645C4.4847 4.28045 4.71568 4.1377 4.96836 4.1377H19.6442ZM10.5425 9.10747L7.91486 5.60528C7.8523 5.52185 7.75431 5.47249 7.65003 5.47186H6.98295C6.85661 5.47186 6.74112 5.54324 6.68462 5.65624C6.62812 5.76924 6.64031 5.90446 6.71611 6.00553L10.0088 10.3416C10.095 10.4564 10.2449 10.5033 10.3811 10.4579C10.5173 10.4125 10.6092 10.285 10.6092 10.1414V9.30759C10.6092 9.23542 10.5858 9.1652 10.5425 9.10747Z"
      fill="currentColor"
    />
    <mask
      id="mask0_3406_10075"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="17"
      height="17"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6442 4.1377C19.8966 4.1377 20.1275 4.28022 20.2406 4.50593C20.3539 4.73201 20.3296 5.00272 20.1779 5.20503L14.3075 13.092V17.8129C14.3068 18.2327 14.1092 18.6278 13.7739 18.8802L12.4397 19.8809C12.2089 20.0544 11.9279 20.148 11.6392 20.1477C10.9046 20.1422 10.3105 19.5481 10.305 18.8135V13.092L4.43469 5.20503C4.28309 5.00289 4.2587 4.73245 4.3717 4.50645C4.4847 4.28045 4.71568 4.1377 4.96836 4.1377H19.6442ZM10.5425 9.10747L7.91486 5.60528C7.8523 5.52185 7.75431 5.47249 7.65003 5.47186H6.98295C6.85661 5.47186 6.74112 5.54324 6.68462 5.65624C6.62812 5.76924 6.64031 5.90446 6.71611 6.00553L10.0088 10.3416C10.095 10.4564 10.2449 10.5033 10.3811 10.4579C10.5173 10.4125 10.6092 10.285 10.6092 10.1414V9.30759C10.6092 9.23542 10.5858 9.1652 10.5425 9.10747Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3406_10075)"></g>
  </svg>
)

export default FilterFilled
